import { gql } from '@apollo/client'

export const GET_ACCOUNTS = gql`
    query getAccounts($input: ListMasaAccountsInput) {
        listMasaAccounts(input: $input) {
            items {
                id
                accountId
                name
                subtype
                type
                provider
                lastUpdated
                amount {
                    currency
                    fiatCurrency
                    fiatValue
                    value
                    __typename
                }
                __typename
            }
            nextToken
            __typename
        }
    }
`
